module.exports = __webpack_public_path__ + "static/img/RWDA465-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWDA465-G_1.png
// module id = pkm3
// module chunks = 0